import useRequest from '@/websdk/utils/request';
export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    name: 'POST_SITE_INSPECTION',
    url: `/api/inspection/site/inferiors/`,
    method: 'POST',
  });


  return [isRequestSuccessed, exec];
});
